var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-area-page job-edit" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [_c("Navigation", { attrs: { page: "job-profiles" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "9" } },
                [
                  _c(
                    "div",
                    {
                      directives: [{ name: "sticky", rawName: "v-sticky" }],
                      staticClass: "sticky-title"
                    },
                    [
                      _c("h1", [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.jobProfileName) +
                            "\n\t\t\t\t\t\t"
                        ),
                        _vm.internal
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-2",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    _vm.editName = true
                                  }
                                }
                              },
                              [
                                _c("Icon", {
                                  staticClass: "ml-1",
                                  attrs: { icon: "pencil", color: "primary" }
                                }),
                                _vm._v(" Ändern\n\t\t\t\t\t\t")
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showReviewIntro && !_vm.internal
                    ? [
                        _c(
                          "div",
                          { staticClass: "job-bot" },
                          [
                            _c("JonMessages", {
                              attrs: { messages: _vm.reviewIntroMessages }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "button-container" },
                              [
                                _c("Button", {
                                  style: {
                                    "animation-delay":
                                      _vm.reviewIntroMessages.length + "s"
                                  },
                                  attrs: {
                                    text: "Los geht's",
                                    icon: "checkmark"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.showReviewIntro = false
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _c("div", { staticClass: "main-content profile-view" }, [
                        _c(
                          "div",
                          {
                            class: [
                              "tag-sections",
                              {
                                "loading-blockade":
                                  _vm.reloadingJobProfile || _vm.saving
                              }
                            ]
                          },
                          _vm._l(_vm.groupedItems, function(item) {
                            return _c(
                              "section",
                              { key: item.area.id },
                              [
                                _c("Title", {
                                  attrs: {
                                    title: item.area.label,
                                    parent: "",
                                    editable: false,
                                    "completion-type": _vm.getGroupCompletionType(
                                      item
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _vm.jobProfileData
                                  ? _c(
                                      "div",
                                      { staticClass: "sub-sections" },
                                      [
                                        _vm.getNonEditableItems(item.area)
                                          .length > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "non-editable-items"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "non-editable-items--items"
                                                  },
                                                  _vm._l(
                                                    _vm.getNonEditableItems(
                                                      item.area
                                                    ),
                                                    function(nonEditableItem) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "non-editable-items--item"
                                                        },
                                                        [
                                                          _c(
                                                            "b-row",
                                                            [
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    md: "4"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "non-editable-items--item-label"
                                                                    },
                                                                    [
                                                                      _vm.inReview &&
                                                                      !_vm.confirming
                                                                        ? _c(
                                                                            "a",
                                                                            {
                                                                              staticClass:
                                                                                "color-default no-hover-color",
                                                                              attrs: {
                                                                                href:
                                                                                  "#"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  $event.preventDefault()
                                                                                  return _vm.edit(
                                                                                    nonEditableItem.inquiry
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                  _vm._s(
                                                                                    _vm.getInquiryLabel(
                                                                                      nonEditableItem.inquiry
                                                                                    )
                                                                                  ) +
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                              )
                                                                            ]
                                                                          )
                                                                        : [
                                                                            _vm._v(
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                _vm._s(
                                                                                  _vm.getInquiryLabel(
                                                                                    nonEditableItem.inquiry
                                                                                  )
                                                                                ) +
                                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                            )
                                                                          ]
                                                                    ],
                                                                    2
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    md: "8"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "non-editable-items--item-values"
                                                                    },
                                                                    [
                                                                      _vm.inReview &&
                                                                      !_vm.isInquiryCompleted(
                                                                        nonEditableItem.inquiry
                                                                      )
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "color-primary"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Bitte gib hier noch die Infos ein."
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._l(
                                                                            _vm.filterLastLevel(
                                                                              nonEditableItem.config.dataProvider(
                                                                                {
                                                                                  jobProfileData:
                                                                                    _vm.jobProfileData
                                                                                }
                                                                              )
                                                                            ),
                                                                            function(
                                                                              valueItem
                                                                            ) {
                                                                              return _c(
                                                                                "div",
                                                                                [
                                                                                  _vm.inReview &&
                                                                                  !_vm.confirming
                                                                                    ? _c(
                                                                                        "a",
                                                                                        {
                                                                                          staticClass:
                                                                                            "color-default no-hover-color",
                                                                                          attrs: {
                                                                                            href:
                                                                                              "#"
                                                                                          },
                                                                                          on: {
                                                                                            click: function(
                                                                                              $event
                                                                                            ) {
                                                                                              $event.preventDefault()
                                                                                              return _vm.edit(
                                                                                                nonEditableItem.inquiry
                                                                                              )
                                                                                            }
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "Label",
                                                                                            {
                                                                                              attrs: {
                                                                                                characteristic:
                                                                                                  valueItem.item,
                                                                                                "label-type":
                                                                                                  _vm.labelTypeJobProfile,
                                                                                                supplements:
                                                                                                  valueItem.supplements
                                                                                              }
                                                                                            }
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : _c(
                                                                                        "Label",
                                                                                        {
                                                                                          attrs: {
                                                                                            characteristic:
                                                                                              valueItem.item,
                                                                                            "label-type":
                                                                                              _vm.labelTypeJobProfile,
                                                                                            supplements:
                                                                                              valueItem.supplements
                                                                                          }
                                                                                        }
                                                                                      )
                                                                                ],
                                                                                1
                                                                              )
                                                                            }
                                                                          ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm.inReview &&
                                                                      !_vm.confirming
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "mt-1"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  attrs: {
                                                                                    href:
                                                                                      "#"
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      $event.preventDefault()
                                                                                      return _vm.edit(
                                                                                        nonEditableItem.inquiry
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "Icon",
                                                                                    {
                                                                                      attrs: {
                                                                                        icon:
                                                                                          "pencil",
                                                                                        color:
                                                                                          "primary"
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tBearbeiten\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ],
                                                                    2
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c("LockInfo", {
                                                  scopedSlots: _vm._u(
                                                    [
                                                      _vm.inReview
                                                        ? {
                                                            key: "default",
                                                            fn: function() {
                                                              return [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\tDiese Angaben zum Job sind im Nachhinein nicht mehr änderbar."
                                                                ),
                                                                _c("br"),
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\tBitte ergänze und ändere daher die Angaben oben.\n\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            },
                                                            proxy: true
                                                          }
                                                        : null
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm._l(item.inquiries, function(
                                          inquiry
                                        ) {
                                          return _vm.isInquiryEditable(inquiry)
                                            ? _c(
                                                "div",
                                                {
                                                  key: inquiry.id,
                                                  staticClass: "sub-section"
                                                },
                                                [
                                                  _c("Title", {
                                                    attrs: {
                                                      title: _vm.getInquiryLabel(
                                                        inquiry
                                                      ),
                                                      editable: _vm.isInquiryEditable(
                                                        inquiry
                                                      ),
                                                      "completion-type": _vm.getInquiryCompletionType(
                                                        inquiry
                                                      )
                                                    },
                                                    on: {
                                                      edit: function($event) {
                                                        return _vm.edit(inquiry)
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.selectedItemsConfigs,
                                                    function(item) {
                                                      return [
                                                        inquiry.id ===
                                                        item.inquiryId
                                                          ? _c(
                                                              "SelectedItems",
                                                              {
                                                                key: inquiry.id,
                                                                class: {
                                                                  inline: _vm.isSelectedItemsInline(
                                                                    item.config,
                                                                    _vm
                                                                      .jobProfileData[
                                                                      item
                                                                        .config
                                                                        .dataProperty
                                                                    ]
                                                                  )
                                                                },
                                                                attrs: {
                                                                  "characteristic-items":
                                                                    _vm.meta[
                                                                      item
                                                                        .config
                                                                        .metaItemsKey
                                                                    ],
                                                                  "characteristic-type":
                                                                    _vm.meta[
                                                                      item
                                                                        .config
                                                                        .metaItemsTypeKey
                                                                    ],
                                                                  selected:
                                                                    item.config
                                                                      .filterLastLevel !==
                                                                    false
                                                                      ? _vm.filterLastLevel(
                                                                          _vm
                                                                            .jobProfileData[
                                                                            item
                                                                              .config
                                                                              .dataProperty
                                                                          ]
                                                                        )
                                                                      : _vm
                                                                          .jobProfileData[
                                                                          item
                                                                            .config
                                                                            .dataProperty
                                                                        ],
                                                                  "label-type":
                                                                    _vm.labelTypeJobProfile,
                                                                  "show-additions":
                                                                    item.config
                                                                      .showAdditions ===
                                                                    true,
                                                                  "show-experience":
                                                                    item.config
                                                                      .suppressExperience !==
                                                                    true,
                                                                  flat:
                                                                    item.config
                                                                      .flat !==
                                                                    false,
                                                                  "none-info":
                                                                    item.config
                                                                      .noneInfo ||
                                                                    "Nein",
                                                                  styling: !item
                                                                    .config
                                                                    .noListStyling
                                                                    ? _vm.selectedItemsStylingList
                                                                    : undefined,
                                                                  "specificities-provider":
                                                                    item.config
                                                                      .specificitiesProvider,
                                                                  "icon-path":
                                                                    item.config
                                                                      .iconPath,
                                                                  clickable: _vm.isInquiryEditable(
                                                                    inquiry
                                                                  )
                                                                },
                                                                on: {
                                                                  editItem: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.edit(
                                                                      inquiry
                                                                    )
                                                                  }
                                                                }
                                                              }
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  inquiry.id ===
                                                  "function-detail"
                                                    ? _c("FunctionDetail", {
                                                        attrs: {
                                                          data:
                                                            _vm.jobProfileData
                                                              .functionDetail
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.edit(
                                                              inquiry
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  inquiry.id === "place-of-work"
                                                    ? _c("PlaceOfWork", {
                                                        attrs: {
                                                          data:
                                                            _vm.jobProfileData
                                                              .placeOfWork
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.edit(
                                                              inquiry
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  inquiry.id === "hiring-date"
                                                    ? _c("HiringDate", {
                                                        attrs: {
                                                          data:
                                                            _vm.jobProfileData
                                                              .hiringDate
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.edit(
                                                              inquiry
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  inquiry.id === "working-hours"
                                                    ? _c("WorkingHours", {
                                                        attrs: {
                                                          data:
                                                            _vm.jobProfileData
                                                              .workingHours
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.edit(
                                                              inquiry
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  inquiry.id ===
                                                  "employment-duration"
                                                    ? _c("EmploymentDuration", {
                                                        attrs: {
                                                          data:
                                                            _vm.jobProfileData
                                                              .employmentDuration
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.edit(
                                                              inquiry
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  inquiry.id === "salary"
                                                    ? _c("Salary", {
                                                        attrs: {
                                                          data:
                                                            _vm.jobProfileData
                                                              .salary
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.edit(
                                                              inquiry
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  inquiry.id === "hourly-rate"
                                                    ? _c("HourlyRate", {
                                                        attrs: {
                                                          data:
                                                            _vm.jobProfileData
                                                              .hourlyRate
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.edit(
                                                              inquiry
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  inquiry.id ===
                                                  "travel-willingness"
                                                    ? _c("TravelWillingness", {
                                                        attrs: {
                                                          data:
                                                            _vm.jobProfileData
                                                              .travelWillingness
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.edit(
                                                              inquiry
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  inquiry.id === "education"
                                                    ? _c("Education", {
                                                        attrs: {
                                                          data:
                                                            _vm.jobProfileData
                                                              .education
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.edit(
                                                              inquiry
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  inquiry.id === "home-office"
                                                    ? _c("HomeOffice", {
                                                        attrs: {
                                                          data:
                                                            _vm.jobProfileData
                                                              .homeOffice
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.edit(
                                                              inquiry
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  inquiry.id ===
                                                  "incognito-mode"
                                                    ? _c("IncognitoMode", {
                                                        attrs: {
                                                          data:
                                                            _vm.jobProfileData
                                                              .incognitoMode
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.edit(
                                                              inquiry
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        }),
                                        _vm._v(" "),
                                        _vm.inReview && !_vm.internal
                                          ? _c(
                                              "div",
                                              { staticClass: "mt-4" },
                                              [
                                                _c("Button", {
                                                  attrs: {
                                                    text: "Bestätigen",
                                                    icon: "checkmark",
                                                    disabled:
                                                      _vm.confirming ||
                                                      !_vm.canConfirm,
                                                    loading: _vm.confirming
                                                  },
                                                  on: { click: _vm.confirm }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.editName
        ? _c(
            "PopUp",
            {
              attrs: {
                title: "Name bearbeiten",
                "ok-text": "Speichern",
                "ok-loading": _vm.changingName,
                "hide-cancel": _vm.changingName,
                "hide-close": _vm.changingName,
                "ok-disabled": !_vm.changeNameDataValid || _vm.changingName
              },
              on: { ok: _vm.saveName, hidden: _vm.onAbortNameChange }
            },
            [
              _c(
                "Group",
                { attrs: { label: "Name" } },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.jobProfileNameToEdit,
                      callback: function($$v) {
                        _vm.jobProfileNameToEdit = $$v
                      },
                      expression: "jobProfileNameToEdit"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4" }, [
                _c("b", [_vm._v("ACHTUNG:")]),
                _vm._v(
                  " dieser Jobtitel wird den Kandidaten angezeigt und darf daher\n\t\t\tkeine Hinweise auf deine Identität und Organisation beinhalten.\n\t\t"
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }